module.exports = __webpack_public_path__ + "static/media/viewSme.0c69a73b.svg";